import 'css/src/components/app/doc-to-script/BlockNode.module.scss';

import { addClassNamesToElement } from '@lexical/utils';
import type { LexicalNode, RangeSelection, SerializedElementNode, Spread } from 'lexical';
import { ElementNode } from 'lexical';

export type SerializedBlockNode = Spread<
    {
        type: 'Block';
        version: 1;
    },
    SerializedElementNode
>;

export class BlockNode extends ElementNode {
    static override getType(): string {
        return 'Block';
    }

    static override clone(node: BlockNode): BlockNode {
        return new BlockNode(node.__key);
    }

    override createDOM(): HTMLElement {
        const dom = document.createElement('div');
        addClassNamesToElement(dom, 'Block');
        return dom;
    }

    override updateDOM(): false {
        return false;
    }

    static override importJSON() {
        return new BlockNode();
    }

    override exportJSON(): SerializedBlockNode {
        return {
            ...super.exportJSON(),
            type: 'Block',
            version: 1,
        };
    }

    override collapseAtStart(): false {
        return false;
    }

    override insertNewAfter(
        selection: RangeSelection,
        restoreSelection: boolean | undefined,
    ): LexicalNode | null {
        const newBlock = new BlockNode();
        const direction = this.getDirection();
        newBlock.setDirection(direction);
        this.insertAfter(newBlock, restoreSelection);
        return newBlock;
    }
}

export function $createBlockNode(): BlockNode {
    return new BlockNode();
}

export function $isBlockNode(node: LexicalNode | null | undefined): boolean {
    return node instanceof BlockNode;
}
